export default "__VITE_ASSET__COUroJ9n__"